import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy danh sách danh mục tin tức theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Danh sách danh mục tin tức
 */
export const getNewsCategoriesByLanguage = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.NEWS_CATEGORIES.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;

        if (data && data.success && Array.isArray(data.data)) {
            return data.data;
        }

        if (Array.isArray(data)) {
            return data;
        }

        if (data && Array.isArray(data.data)) {
            return data.data;
        }

        return [];
    } catch (error) {
        console.error("Lỗi khi lấy danh sách danh mục tin tức:", error);
        throw error;
    }
};


export const getNewsCategories = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.NEWS_CATEGORIES.GET_ALL, { params });
    return response.data;
};

export const getNewsCategoryById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.NEWS_CATEGORIES.GET_BY_ID(id));
    return response.data;
};

export const createNewsCategory = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.NEWS_CATEGORIES.CREATE, data);
    return response.data;
};

export const updateNewsCategory = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.NEWS_CATEGORIES.UPDATE(id), data);
    return response.data;
};

export const deleteNewsCategory = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.NEWS_CATEGORIES.DELETE(id));
    return response.data;
};
